import BaseVariantImages from './BaseVariantImages'

const VariantImages = {
  ...BaseVariantImages,
  // Logos
  Logo: require('./img/variants/ptp/logo.png'),
  LogoPrimary: require('./img/variants/ptp/logoPrimary.png'),
  // Stores
  GooglePlay: require('./img/variants/ptp/googlePlay.svg'),
  AppStore: require('./img/variants/ptp/appStore.svg'),
  // Medias
  Medias: require('./img/variants/ptp/medias.svg'),
}

export default VariantImages
